import {GetDiscountsResponse_Discount} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';
import {useCallback} from 'react';
import {useDiscounts, useDiscountsCallback} from '../hooks/useDiscounts';

const getCampaignKeyFromSelectedDiscount = ({
  discount,
}: {
  discount?: GetDiscountsResponse_Discount;
}) => {
  if (discount) {
    const {type: campaignType} = discount.campaign;
    switch (campaignType?.$case) {
      case 'minor':
        return campaignType.minor.campaignKey ?? null;
      case 'reduction':
        return campaignType.reduction.campaignKey ?? null;
      default:
        return null;
    }
  }

  return null;
};

export const useCampaignKey = () => {
  const selectedDiscount = useDiscounts();
  return selectedDiscount.data?.discount
    ? getCampaignKeyFromSelectedDiscount({
        discount: selectedDiscount.data?.discount,
      })
    : null;
};

export const useCampaignKeyCallback = () => {
  const selectedDiscountCallback = useDiscountsCallback();
  return useCallback(async () => {
    const selectedDiscount = await selectedDiscountCallback();
    if (!selectedDiscount.discount) {
      return null;
    }
    return getCampaignKeyFromSelectedDiscount({
      discount: selectedDiscount.discount,
    });
  }, [selectedDiscountCallback]);
};
